/* Explicitly opened preferences only. The initial Shopify banner stays untouched. */
(() => {
  'use strict';
  if (window.__mmCookiePreferences) return;
  window.__mmCookiePreferences = true;

  const triggerSelector = 'a[href$="#shopifyReshowConsentBanner"], [data-mm-cookie-preferences]';
  const purposes = ['analytics', 'marketing', 'preferences'];
  const timeoutMs = 8000;
  let dialog;
  let notice;
  let opener;
  let loading = false;
  let saving = false;

  function privacyApi() {
    const api = window.Shopify?.customerPrivacy;
    return typeof api?.currentVisitorConsent === 'function' && typeof api?.setTrackingConsent === 'function' ? api : null;
  }

  function showNotice(message, error = false) {
    if (!notice) {
      notice = document.createElement('p');
      notice.className = 'mm-cookie-preferences mm-cookie-preferences--notice';
      notice.tabIndex = -1;
    }
    notice.setAttribute('role', error ? 'alert' : 'status');
    notice.textContent = message;
    notice.hidden = false;
    if (opener?.isConnected) opener.insertAdjacentElement('afterend', notice);
    else document.body.append(notice);
    if (error) notice.focus();
  }

  function message(text, error = false) {
    const status = dialog.querySelector('[data-mm-preferences-status]');
    status.setAttribute('role', error ? 'alert' : 'status');
    status.textContent = text;
  }

  function close() {
    if (dialog?.open) dialog.close();
  }

  function busy(value) {
    saving = value;
    dialog.setAttribute('aria-busy', String(value));
    dialog.querySelectorAll('[data-mm-preference], [data-mm-preferences-action]').forEach(control => {
      control.disabled = value;
    });
  }

  function save(choice) {
    if (saving || !dialog?.open) return;
    const api = privacyApi();
    if (!api) {
      message('Die Cookie-Einstellungen sind gerade nicht erreichbar. Bitte lade die Seite neu.', true);
      return;
    }
    // Only these three explicit choices are written. The separate data-sale signal is not changed.
    const selection = {};
    purposes.forEach(purpose => {
      selection[purpose] = choice === 'accept' || (choice === 'selection' && dialog.querySelector(`[data-mm-preference="${purpose}"]`).checked);
    });
    busy(true);
    message('Deine Auswahl wird gespeichert …');
    let settled = false;
    const finish = error => {
      if (settled) return;
      settled = true;
      window.clearTimeout(timer);
      busy(false);
      if (error) {
        const text = 'Das Speichern konnte nicht bestätigt werden. Bitte lade die Seite neu und prüfe deine Auswahl.';
        message(text, true);
        if (!dialog.open) showNotice(text, true);
      } else {
        message('Deine Cookie-Auswahl wurde gespeichert.');
        close();
      }
    };
    const timer = window.setTimeout(() => finish(true), timeoutMs);
    try {
      api.setTrackingConsent(selection, result => {
        finish(Boolean(result && (result instanceof Error || typeof result !== 'object' || result.error)));
      });
    } catch (_) {
      finish(true);
    }
  }

  function createDialog() {
    const element = document.createElement('dialog');
    element.className = 'mm-cookie-preferences';
    element.setAttribute('aria-labelledby', 'MMCookiePreferencesTitle');
    element.setAttribute('aria-describedby', 'MMCookiePreferencesDescription');
    element.innerHTML = `
      <div class="mm-cookie-preferences__heading">
        <h2 id="MMCookiePreferencesTitle" tabindex="-1">Cookie-Einstellungen</h2>
        <button type="button" class="mm-cookie-preferences__close" data-mm-preferences-close>Schließen</button>
      </div>
      <p id="MMCookiePreferencesDescription">Du entscheidest, welche optionalen Cookies du erlaubst. Du kannst deine Auswahl jederzeit hier ändern.</p>
      <div class="mm-cookie-preferences__options">
        <label class="mm-cookie-preferences__option"><input type="checkbox" checked disabled><span><strong>Notwendige Cookies – immer aktiv</strong><small>Sie ermöglichen grundlegende Funktionen wie den Warenkorb und das Speichern deiner Cookie-Auswahl.</small></span></label>
        <label class="mm-cookie-preferences__option"><input type="checkbox" data-mm-preference="analytics"><span><strong>Analyse</strong><small>Hilft uns zu verstehen, wie der Shop genutzt wird.</small></span></label>
        <label class="mm-cookie-preferences__option"><input type="checkbox" data-mm-preference="marketing"><span><strong>Marketing</strong><small>Ermöglicht interessenbezogene Werbung und die Messung von Marketingmaßnahmen.</small></span></label>
        <label class="mm-cookie-preferences__option"><input type="checkbox" data-mm-preference="preferences"><span><strong>Präferenzen</strong><small>Merkt sich Einstellungen, zum Beispiel deine Sprache.</small></span></label>
      </div>
      <p>Mehr dazu in unserer <a href="/policies/privacy-policy">Datenschutzerklärung</a>.</p>
      <p class="mm-cookie-preferences__status" data-mm-preferences-status role="status" aria-live="polite" aria-atomic="true"></p>
      <div class="mm-cookie-preferences__actions">
        <button type="button" data-mm-preferences-action="reject">Alle ablehnen</button>
        <button type="button" data-mm-preferences-action="selection">Auswahl speichern</button>
        <button type="button" data-mm-preferences-action="accept">Alle akzeptieren</button>
      </div>`;
    element.querySelector('[data-mm-preferences-close]').addEventListener('click', close);
    element.querySelectorAll('[data-mm-preferences-action]').forEach(button => {
      button.addEventListener('click', () => save(button.dataset.mmPreferencesAction));
    });
    element.addEventListener('cancel', event => {
      event.preventDefault();
      close();
    });
    element.addEventListener('close', () => {
      if (opener?.isConnected) opener.focus({ preventScroll: true });
    });
    // Native dialog makes the background inert. Keep Tab deterministic at both edges, too.
    element.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const controls = [...element.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href]')];
      const first = controls[0];
      const last = controls[controls.length - 1];
      if ((event.shiftKey && (document.activeElement === first || !controls.includes(document.activeElement))) ||
          (!event.shiftKey && (document.activeElement === last || !controls.includes(document.activeElement)))) {
        event.preventDefault();
        (event.shiftKey ? last : first)?.focus();
      }
    });
    document.body.append(element);
    return element;
  }

  function open() {
    const api = privacyApi();
    if (!api) return showNotice('Die Cookie-Einstellungen konnten nicht geladen werden. Bitte lade die Seite neu.', true);
    if (dialog?.open) return;
    let consent;
    try {
      consent = api.currentVisitorConsent();
    } catch (_) {
      return showNotice('Deine Cookie-Auswahl konnte nicht gelesen werden. Bitte lade die Seite neu.', true);
    }
    dialog ||= createDialog();
    if (typeof dialog.showModal !== 'function') {
      return showNotice('Die Cookie-Einstellungen benötigen einen aktuellen Browser.', true);
    }
    if (!saving) {
      purposes.forEach(purpose => {
        dialog.querySelector(`[data-mm-preference="${purpose}"]`).checked = consent?.[purpose] === 'yes';
      });
      message('');
    }
    try {
      dialog.showModal();
      if (notice) notice.hidden = true;
      dialog.querySelector('h2').focus();
    } catch (_) {
      showNotice('Die Cookie-Einstellungen konnten nicht geöffnet werden. Bitte lade die Seite neu.', true);
    }
  }

  function requestOpen(trigger) {
    if (loading || dialog?.open) return;
    opener = trigger;
    if (privacyApi()) return open();
    if (typeof window.Shopify?.loadFeatures !== 'function') {
      return showNotice('Die Cookie-Einstellungen sind gerade nicht erreichbar. Bitte lade die Seite neu.', true);
    }
    loading = true;
    showNotice('Cookie-Einstellungen werden geladen …');
    const oldBusy = trigger.getAttribute('aria-busy');
    trigger.setAttribute('aria-busy', 'true');
    let settled = false;
    const finish = error => {
      if (settled) return;
      settled = true;
      window.clearTimeout(timer);
      loading = false;
      if (oldBusy === null) trigger.removeAttribute('aria-busy');
      else trigger.setAttribute('aria-busy', oldBusy);
      if (error || !privacyApi()) showNotice('Die Cookie-Einstellungen konnten nicht geladen werden. Bitte lade die Seite neu.', true);
      else open();
    };
    const timer = window.setTimeout(() => finish(true), timeoutMs);
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => finish(Boolean(error)));
    } catch (_) {
      finish(true);
    }
  }

  document.addEventListener('click', event => {
    const trigger = event.target instanceof Element ? event.target.closest(triggerSelector) : null;
    if (!trigger) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    requestOpen(trigger);
  }, true);
})();
